// @ts-nocheck
/**
 * カード詳細モーダル
 *
 * カードの詳細情報表示と売却機能
 */

import React, { useState } from 'react';
import { ATTRIBUTE_COLORS } from '../../utils/constants';
import { RARITY_COLORS, RARITY_NAMES, RARITY_MULTIPLIERS } from '../data/constants';
import { currencyManager } from '../systems/currencyManager';
import { getSellPrice } from '../systems/shopSystem';
import { PriceHistoryPanel } from './PriceHistoryPanel';
import { useIsMobile } from '../hooks/useMediaQuery';
import { CardV2, RarityEffectLayer } from '../../components/cardV2';

// ========================================
// スタイル定義
// ========================================

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: 'linear-gradient(135deg, #1a1a3a 0%, #2a2a4a 100%)',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '500px',
    width: '90%',
    maxHeight: '90vh',
    overflowY: 'auto',
    border: '2px solid #6b4ce6',
    boxShadow: '0 0 50px rgba(107,76,230,0.5)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  cardPreview: {
    width: '120px',
    height: '160px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flexShrink: 0,
  },
  cardPreviewHeader: {
    padding: '6px 8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'rgba(0,0,0,0.3)',
  },
  cardPreviewBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
  },
  headerInfo: {
    flex: 1,
    marginLeft: '16px',
  },
  cardName: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '8px',
  },
  cardMeta: {
    fontSize: '14px',
    color: '#a0a0a0',
    marginBottom: '4px',
  },
  rarityRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
  },
  rarityBadge: {
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
  },
  quantityText: {
    fontSize: '16px',
    color: '#ffd700',
    fontWeight: 'bold',
  },
  closeButton: {
    padding: '4px 8px',
    background: 'transparent',
    border: 'none',
    color: '#a0a0a0',
    fontSize: '24px',
    cursor: 'pointer',
    transition: 'color 0.2s',
  },
  section: {
    marginBottom: '16px',
  },
  sectionTitle: {
    fontSize: '14px',
    color: '#a0a0a0',
    marginBottom: '8px',
    borderBottom: '1px solid rgba(107,76,230,0.3)',
    paddingBottom: '4px',
  },
  effectText: {
    fontSize: '13px',
    color: '#e0e0e0',
    lineHeight: '1.6',
    whiteSpace: 'pre-wrap',
  },
  statsRow: {
    display: 'flex',
    gap: '24px',
    marginBottom: '8px',
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  statLabel: {
    fontSize: '12px',
    color: '#a0a0a0',
  },
  statValue: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#fff',
  },
  valueSection: {
    background: 'rgba(0,0,0,0.3)',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '16px',
  },
  valueRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  valueLabel: {
    fontSize: '13px',
    color: '#a0a0a0',
  },
  valueAmount: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#ffd700',
  },
  tierBadge: {
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
  },
  sellSection: {
    borderTop: '1px solid rgba(107,76,230,0.3)',
    paddingTop: '16px',
    marginTop: '16px',
  },
  sellRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
  sellQuantityControl: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  quantityButton: {
    width: '32px',
    height: '32px',
    borderRadius: '6px',
    border: 'none',
    background: 'rgba(107,76,230,0.5)',
    color: '#fff',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  quantityInput: {
    width: '50px',
    textAlign: 'center',
    padding: '6px',
    borderRadius: '6px',
    border: '1px solid rgba(107,76,230,0.5)',
    background: 'rgba(30,30,50,0.8)',
    color: '#e0e0e0',
    fontSize: '14px',
  },
  sellButton: {
    padding: '10px 24px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
    color: '#fff',
    transition: 'all 0.3s ease',
  },
  sellButtonDisabled: {
    background: 'rgba(100,100,100,0.5)',
    cursor: 'not-allowed',
  },
  // 価格チャートセクション
  chartToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px',
  },
  chartToggleButton: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid rgba(107,156,230,0.5)',
    background: 'rgba(107,156,230,0.1)',
    color: '#9dc4ff',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  chartToggleButtonActive: {
    background: 'rgba(107,156,230,0.3)',
    borderColor: 'rgba(107,156,230,0.8)',
  },
  chartSection: {
    background: 'rgba(0,0,0,0.3)',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    border: '1px solid rgba(107,156,230,0.3)',
  },
  chartHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  chartTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#9dc4ff',
  },
  chartStats: {
    display: 'flex',
    gap: '16px',
    marginTop: '12px',
    flexWrap: 'wrap',
  },
  chartStat: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  chartStatLabel: {
    fontSize: '11px',
    color: '#808080',
  },
  chartStatValue: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#e0e0e0',
  },
  noChartData: {
    textAlign: 'center',
    padding: '24px',
    color: '#808080',
    fontSize: '13px',
  },
};

// ========================================
// ティアカラー
// ========================================

const TIER_COLORS = {
  S: '#ffd700',
  A: '#c0c0c0',
  B: '#cd7f32',
  C: '#4ade80',
  D: '#a0a0a0',
};

// ========================================
// メインコンポーネント
// ========================================

const CardDetail = ({
  card,
  rarity,
  quantity,
  valueInfo,
  priceHistory,
  marketState,
  onClose,
  onSell,
}) => {
  const isMobile = useIsMobile();
  const [sellQuantity, setSellQuantity] = useState(1);
  const [showChart, setShowChart] = useState(false);

  const colors = ATTRIBUTE_COLORS[card.attribute] || ATTRIBUTE_COLORS['なし'];
  const rarityColor = RARITY_COLORS[rarity] || '#808080';
  const isMonster = card.type === 'monster';

  // 売却価格計算（市場変動込み）
  const baseValue = valueInfo?.baseValue || 0;
  const tier = valueInfo?.tier || 'D';
  const baseSellPrice = valueInfo?.rarityValues?.[rarity] || baseValue;
  const sellPriceInfo = getSellPrice(card, rarity, marketState);
  const sellPrice = sellPriceInfo.price;
  const marketModifier = sellPriceInfo.modifier;
  const totalSellPrice = sellPrice * sellQuantity;

  // レアリティ倍率（価格履歴パネルで使用）
  const rarityMultiplier = RARITY_MULTIPLIERS[rarity] || 1;

  // 売却数量の調整
  const handleQuantityChange = (delta) => {
    const newQty = Math.max(1, Math.min(quantity, sellQuantity + delta));
    setSellQuantity(newQty);
  };

  // 売却実行
  const handleSell = () => {
    if (sellQuantity > 0 && sellQuantity <= quantity) {
      onSell(card.id, rarity, sellQuantity, card);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={{
        ...styles.modal,
        padding: isMobile ? '16px' : '24px',
        maxWidth: isMobile ? '340px' : '500px',
      }} onClick={(e) => e.stopPropagation()}>
        {/* ヘッダー */}
        <div style={{
          ...styles.header,
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '12px' : '0',
        }}>
          {/* カードプレビュー（CardV2 + RarityEffectLayer） */}
          <div style={{
            alignSelf: isMobile ? 'center' : 'flex-start',
            flexShrink: 0,
          }}>
            <RarityEffectLayer
              rarity={rarity}
              effectLevel="full"
              width={isMobile ? 100 : 120}
              height={isMobile ? 130 : 156}
              enableMouseEffect={true}
            >
              <CardV2
                card={card}
                displayMode="pack"
                displayWidth={isMobile ? 100 : 120}
              />
            </RarityEffectLayer>
          </div>

          {/* カード情報 */}
          <div style={{
            ...styles.headerInfo,
            marginLeft: isMobile ? '0' : '16px',
            textAlign: isMobile ? 'center' : 'left',
          }}>
            <div style={{
              ...styles.cardName,
              fontSize: isMobile ? '18px' : '20px',
            }}>{card.name}</div>
            <div style={{
              ...styles.cardMeta,
              fontSize: isMobile ? '13px' : '14px',
            }}>
              {card.attribute} / {card.type === 'monster' ? 'モンスター' : card.type === 'magic' ? '魔法' : card.type === 'field' ? 'フィールド' : 'フェイズ'}
            </div>
            {card.category && (
              <div style={{
                ...styles.cardMeta,
                fontSize: isMobile ? '13px' : '14px',
              }}>{card.category}</div>
            )}
            <div style={{
              ...styles.rarityRow,
              justifyContent: isMobile ? 'center' : 'flex-start',
            }}>
              <div style={{
                ...styles.rarityBadge,
                background: rarityColor,
                fontSize: isMobile ? '13px' : '14px',
              }}>
                {RARITY_NAMES[rarity] || rarity}
              </div>
              <span style={{
                ...styles.quantityText,
                fontSize: isMobile ? '14px' : '16px',
              }}>×{quantity}</span>
            </div>
          </div>

          {/* 閉じるボタン */}
          <button
            style={styles.closeButton}
            onClick={onClose}
            onMouseEnter={(e) => e.target.style.color = '#fff'}
            onMouseLeave={(e) => e.target.style.color = '#a0a0a0'}
          >
            ×
          </button>
        </div>

        {/* ステータス（モンスターのみ） */}
        {isMonster && (
          <div style={styles.section}>
            <div style={styles.sectionTitle}>ステータス</div>
            <div style={styles.statsRow}>
              <div style={styles.statItem}>
                <span style={styles.statLabel}>攻撃力:</span>
                <span style={{...styles.statValue, color: '#ff6b6b'}}>{card.attack}</span>
              </div>
              <div style={styles.statItem}>
                <span style={styles.statLabel}>HP:</span>
                <span style={{...styles.statValue, color: '#4ade80'}}>{card.hp}</span>
              </div>
              <div style={styles.statItem}>
                <span style={styles.statLabel}>コスト:</span>
                <span style={{...styles.statValue, color: '#6b9dff'}}>{card.cost}</span>
              </div>
            </div>
          </div>
        )}

        {/* 効果テキスト */}
        {card.effect && (
          <div style={styles.section}>
            <div style={styles.sectionTitle}>効果</div>
            <div style={styles.effectText}>{card.effect}</div>
          </div>
        )}

        {/* 価値情報 */}
        <div style={styles.valueSection}>
          <div style={styles.valueRow}>
            <span style={styles.valueLabel}>ティア</span>
            <div style={{
              ...styles.tierBadge,
              background: TIER_COLORS[tier] || '#808080',
            }}>
              {tier}ティア
            </div>
          </div>
          <div style={styles.valueRow}>
            <span style={styles.valueLabel}>基礎価値</span>
            <span style={styles.valueAmount}>{baseValue.toLocaleString()}G</span>
          </div>
          <div style={styles.valueRow}>
            <span style={styles.valueLabel}>レアリティ倍率</span>
            <span style={{...styles.valueAmount, color: '#e0e0e0'}}>×{RARITY_MULTIPLIERS[rarity] || 1}</span>
          </div>
          {marketModifier !== 0 && (
            <div style={styles.valueRow}>
              <span style={styles.valueLabel}>市場変動</span>
              <span style={{
                ...styles.valueAmount,
                color: marketModifier > 0 ? '#4ade80' : '#ff6b6b',
              }}>
                {marketModifier > 0 ? '+' : ''}{marketModifier}%
              </span>
            </div>
          )}
          <div style={{...styles.valueRow, borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '8px'}}>
            <span style={styles.valueLabel}>売却価格（1枚）</span>
            <span style={{
              ...styles.valueAmount,
              color: marketModifier > 0 ? '#4ade80' : marketModifier < 0 ? '#ff6b6b' : '#ffd700',
            }}>
              {sellPrice.toLocaleString()}G
            </span>
          </div>

          {/* 価格推移トグル */}
          <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <button
              style={{
                ...styles.chartToggleButton,
                ...(showChart ? styles.chartToggleButtonActive : {}),
                width: '100%',
                justifyContent: 'center',
              }}
              onClick={() => setShowChart(!showChart)}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(107,156,230,0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = showChart ? 'rgba(107,156,230,0.3)' : 'rgba(107,156,230,0.1)';
              }}
            >
              📈 価格推移を{showChart ? '閉じる' : '見る'}
            </button>
          </div>
        </div>

        {/* 価格チャートセクション（サーバーベース） */}
        {showChart && (
          <div style={{ marginBottom: '16px' }}>
            <PriceHistoryPanel
              cardId={card.id}
              rarityMultiplier={rarityMultiplier}
              chartHeight={isMobile ? 120 : 150}
            />
          </div>
        )}

        {/* 売却セクション */}
        {quantity > 0 && onSell && (
          <div style={{
            ...styles.sellSection,
            paddingTop: isMobile ? '12px' : '16px',
            marginTop: isMobile ? '12px' : '16px',
          }}>
            <div style={{
              ...styles.sellRow,
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '12px' : '16px',
              alignItems: isMobile ? 'stretch' : 'center',
            }}>
              <div style={{
                ...styles.sellQuantityControl,
                justifyContent: isMobile ? 'center' : 'flex-start',
              }}>
                <button
                  style={{
                    ...styles.quantityButton,
                    width: isMobile ? '28px' : '32px',
                    height: isMobile ? '28px' : '32px',
                    fontSize: isMobile ? '16px' : '18px',
                  }}
                  onClick={() => handleQuantityChange(-1)}
                  disabled={sellQuantity <= 1}
                >
                  -
                </button>
                <input
                  type="number"
                  style={{
                    ...styles.quantityInput,
                    width: isMobile ? '45px' : '50px',
                    fontSize: isMobile ? '13px' : '14px',
                  }}
                  value={sellQuantity}
                  onChange={(e) => {
                    const val = parseInt(e.target.value) || 1;
                    setSellQuantity(Math.max(1, Math.min(quantity, val)));
                  }}
                  min={1}
                  max={quantity}
                />
                <button
                  style={{
                    ...styles.quantityButton,
                    width: isMobile ? '28px' : '32px',
                    height: isMobile ? '28px' : '32px',
                    fontSize: isMobile ? '16px' : '18px',
                  }}
                  onClick={() => handleQuantityChange(1)}
                  disabled={sellQuantity >= quantity}
                >
                  +
                </button>
                <span style={{color: '#a0a0a0', fontSize: isMobile ? '12px' : '13px'}}>
                  / {quantity}枚
                </span>
              </div>

              <div style={{textAlign: isMobile ? 'center' : 'right'}}>
                <div style={{fontSize: isMobile ? '11px' : '12px', color: '#a0a0a0'}}>売却合計</div>
                <div style={{fontSize: isMobile ? '16px' : '18px', fontWeight: 'bold', color: '#ffd700'}}>
                  {totalSellPrice.toLocaleString()}G
                </div>
              </div>
            </div>

            <button
              style={{
                ...styles.sellButton,
                width: '100%',
                marginTop: isMobile ? '10px' : '12px',
                padding: isMobile ? '8px 20px' : '10px 24px',
                fontSize: isMobile ? '13px' : '14px',
              }}
              onClick={handleSell}
            >
              売却する
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardDetail;
